import { render, staticRenderFns } from "./DataSekolah.vue?vue&type=template&id=887df00c"
import script from "./DataSekolah.vue?vue&type=script&lang=js"
export * from "./DataSekolah.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports